module.exports = __webpack_public_path__ + "static/img/sg_btn2.e0ade6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/sg_btn2.png
// module id = m9b3
// module chunks = 7